export const SCOPE_FINANCE_FUEL_CARD        = "SCOPE_FINANCE_FUEL_CARD";
export const SCOPE_FUEL_CARD_UPLOAD         = "SCOPE_FINANCE_FUEL_CARD_UPLOAD";
export const SCOPE_FUEL_CARD_VIEW           = "SCOPE_FINANCE_FUEL_CARD_VIEW";
export const SCOPE_FUEL_CARD_REPORT_DELETE  = "SCOPE_FINANCE_FUEL_CARD_REPORT_DELETE";
export const SCOPE_FUEL_CARD_VIEW_DETAIL    = "SCOPE_FINANCE_FUEL_CARD_VIEW_DETAIL";
export const SCOPE_FUEL_CARD_EDIT           = "SCOPE_FINANCE_FUEL_CARD_EDIT";
export const SCOPE_FUEL_CARD_DELETE         = "SCOPE_FINANCE_FUEL_CARD_DELETE";